import { useMemo } from 'react';
import { createAnalyticsClient, type AnalyticsClient } from '../api/analyticsClient.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link AnalyticsClient} to the current auth session, mirroring {@link useShowClient}.
 * The client reads the access token through the getter on each request (§32.3).
 */
export function useAnalyticsClient(): AnalyticsClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createAnalyticsClient(getAccessToken), [getAccessToken]);
}
